const families = [
  ["Material Symbols Outlined", "data-material-icons-ready"],
  ["Celia Interface Symbols", "data-interface-icons-ready"],
] as const;

/** Page-lifetime readiness for the shared icon faces.
 * FontFaceSet.check() alone also returns true for a missing family. Only an
 * actual loaded face may reveal ligatures; failed downloads stay concealed.
 */
export function watchIconFonts(): void {
  const fonts = document.fonts;
  function update() {
    const loaded = new Set([...fonts].filter((face) => face.status === "loaded")
      .map((face) => face.family.replace(/["']/g, "")));
    for (const [family, attribute] of families) {
      document.documentElement.toggleAttribute(attribute, loaded.has(family));
    }
  }
  fonts.addEventListener("loadingdone", update);
  fonts.addEventListener("loadingerror", update);
  update();
  // Per-family promises reveal icons even while unrelated text fonts load.
  for (const [family] of families) {
    void fonts.load(`400 20px "${family}"`).then(update, update);
  }
}
